<div class="container">
    <div class="login-container" *ngIf="!isLogged">
        <mat-form-field class="full-input-grid" appearance="outline">
            <mat-label>{{ 'admin.token' | translate }}</mat-label>
            <input type="text" matInput [(ngModel)]="token">
        </mat-form-field>
        <div>
            <button class="full-input-grid button" mat-raised-button color="primary" (click)="signup()">{{
                'signIn.enterButton' | translate }}</button>
        </div>
    </div>

    <div class="content-container" *ngIf="isLogged">
        <h1>{{appName}} - Área Administrativa</h1>
        <mat-tab-group>
            <mat-tab>
                <ng-template mat-tab-label>
                    <span>Configurações</span>
                </ng-template>
                <div>
                    <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="demo-table"
                        *ngIf="configurations.length" mat-sort>
                        <ng-container matColumnDef="column-link">
                            <th class="column-link" mat-header-cell *matHeaderCellDef> {{ 'admin.link' | translate |
                                titlecase}}
                            </th>
                            <td class="link" mat-cell *matCellDef="let element">
                                <span *ngIf="!element.editingLink">{{element.link}}</span>
                                <mat-form-field *ngIf="element.editingLink"
                                    class="full-input-grid no-padding mat-form-field-no-hint" appearance="outline">
                                    <input id="txtName" [type]="element.id === 8 ? 'number' : 'text'" matInput
                                        [(ngModel)]="element.link" class="center-input-text">
                                    <div matSuffix>
                                        <button appearance="fill" class="invisible-button"
                                            (click)="saveLinkEdition(element)">
                                            <mat-icon class="color-green">done</mat-icon>
                                        </button>
                                        <button appearance="fill" class="invisible-button"
                                            (click)="cancelLinkEdition(element)">
                                            <mat-icon class="color-red">close</mat-icon>
                                        </button>
                                    </div>
                                </mat-form-field>
                            </td>
                            <input [hidden]="element.editing" class="name" mat-cell *matCellDef="let element"
                                style="width: 100px" />
                        </ng-container>

                        <ng-container matColumnDef="column-id">
                            <th class="column-id" mat-header-cell *matHeaderCellDef> {{ 'admin.flag' | translate }}</th>
                            <td class="id" mat-cell *matCellDef="let element"> {{element.flag}}</td>
                        </ng-container>

                        <ng-container matColumnDef="column-flag">
                            <th class="column-flag" mat-header-cell *matHeaderCellDef> {{ 'admin.id' | translate |
                                titlecase}}
                            </th>
                            <td class="flag" mat-cell *matCellDef="let element"> {{element.id}}</td>
                        </ng-container>

                        <ng-container matColumnDef="column-options">
                            <th class="column-options" mat-header-cell *matHeaderCellDef></th>
                            <td class="options" mat-cell *matCellDef="let element">
                                <div class="options-buttons">
                                    <button (click)="editConfigurationLink(element)" class="blue-btn">
                                        <span>{{'admin.editButton' | translate}}</span>
                                    </button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    <span>Arquivos Temporários</span>
                </ng-template>
                <div id="filters-container">
                    <form [formGroup]="formGroup" class="form-filter">
                        <mat-form-field appearance="outline">
                            <mat-label>{{ 'admin.temp-files.filter.begin-date' | translate }}</mat-label>
                            <input matInput [matDatepicker]="picker1" formControlName="beginDate"
                                (change)="changeBeginDate($event)">
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>
                            <mat-error
                                *ngIf="formGroup.controls.beginDate.invalid && formGroup.controls.beginDate.touched">
                                <mat-error
                                    *ngIf="formGroup.controls.beginDate.hasError('startDateGreaterThanFinalDate')">
                                    {{messageService.startDateGreaterThanFinalDate()}}
                                </mat-error>
                                <mat-error *ngIf="formGroup.controls.beginDate.hasError('startDateGreaterThanToday')">
                                    {{messageService.startDateGreaterThanToday()}}
                                </mat-error>
                                <mat-error *ngIf="formGroup.controls.beginDate.hasError('invalid')">
                                    {{messageService.errorMessage(formGroup.controls.beginDate)}}
                                </mat-error>
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>{{ 'admin.temp-files.filter.end-date' | translate }}</mat-label>
                            <input matInput [matDatepicker]="picker2" formControlName="endDate"
                                (change)="changeEndDate($event)">
                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                            <mat-datepicker #picker2></mat-datepicker>
                            <mat-error *ngIf="formGroup.controls.endDate.invalid && formGroup.controls.endDate.touched">
                                <mat-error *ngIf="formGroup.controls.endDate.hasError('endDateMinorThanStartDate')">
                                    {{messageService.endDateMinorThanStartDate()}}
                                </mat-error>
                                <mat-error *ngIf="formGroup.controls.endDate.hasError('invalid')">
                                    {{messageService.errorMessage(formGroup.controls.endDate)}}
                                </mat-error>
                            </mat-error>
                        </mat-form-field>
                        <button mat-flat-button id="filterButton" class="btn-yes-wizard" (click)="clickFilterButton()">
                            {{"filter" | translate}}
                        </button>
                    </form>
                </div>
                <div>
                    <table mat-table [dataSource]="dataSourceTempFile" multiTemplateDataRows class="demo-table"
                        mat-sort>
                        <ng-container matColumnDef="companyEmail">
                            <th class="header-company-email" mat-header-cell *matHeaderCellDef> {{
                                'admin.temp-files.column.company-email' | translate }}</th>
                            <td class="cell-company-email" mat-cell *matCellDef="let element"> {{ element.companyEmail
                                }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="companyDocument">
                            <th class="header-company-document" mat-header-cell *matHeaderCellDef> {{
                                'admin.temp-files.column.company-document' | translate }}</th>
                            <td class="cell-company-document" mat-cell *matCellDef="let element"> {{
                                element.companyDocument | DocumentFormatPipe
                                }} </td>
                        </ng-container>

                        <ng-container matColumnDef="userName">
                            <th class="header-user-name" mat-header-cell *matHeaderCellDef> {{
                                'admin.temp-files.column.user-name' | translate }}</th>
                            <td class="cell-user-name" mat-cell *matCellDef="let element"> {{ element.userName }} </td>
                        </ng-container>

                        <ng-container matColumnDef="pdvIdDescription">
                            <th class="header-pdv" mat-header-cell *matHeaderCellDef> {{ 'admin.temp-files.column.pos' |
                                translate }}</th>
                            <td class="cell-pdv" mat-cell *matCellDef="let element"> {{ element.pdvIdDescription }}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="dateUpload">
                            <th class="header-date-upload" mat-header-cell *matHeaderCellDef> {{
                                'admin.temp-files.column.date' | translate }}</th>
                            <td class="cell-date-upload" mat-cell *matCellDef="let element"> {{ element.dateUpload |
                                DateTimeFormatPipe }} </td>
                        </ng-container>

                        <ng-container matColumnDef="fileName">
                            <th class="header-file-name" mat-header-cell *matHeaderCellDef> {{
                                'admin.temp-files.column.file-name' | translate }}</th>
                            <td class="cell-file-name" mat-cell *matCellDef="let element"> {{ element.fileName }} </td>
                        </ng-container>

                        <ng-container matColumnDef="fileSize">
                            <th class="header-file-size" mat-header-cell *matHeaderCellDef> {{
                                'admin.temp-files.column.file-size' | translate }}</th>
                            <td class="cell-file-size" mat-cell *matCellDef="let element"> {{ element.fileSize }} </td>
                        </ng-container>

                        <ng-container matColumnDef="status">
                            <th class="header-status" mat-header-cell *matHeaderCellDef> {{
                                'admin.temp-files.column.status'
                                | translate }}</th>
                            <td class="cell-status" mat-cell *matCellDef="let element"> {{
                                'admin.temp-files.column.status-options.'+element.statusId | translate }} </td>
                        </ng-container>

                        <ng-container matColumnDef="download">
                            <th class="header-download" mat-header-cell *matHeaderCellDef></th>
                            <td class="cell-download" mat-cell *matCellDef="let element">
                                <button *ngIf="element.statusId != tempFileStatusEnum.Error" class="blue-btn"
                                    (click)="clickDownloadButton(element.url)">{{ "Download" }}</button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="tempFileColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: tempFileColumns;"></tr>

                        <tr class="mat-row-no-data" *matNoDataRow>
                            <td class="mat-cell-no-data" [attr.colspan]="tempFileColumns.length">
                                {{ "admin.temp-files.none-found" | translate }}
                            </td>
                        </tr>
                    </table>
                </div>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    <span>Gerencimento de Contas</span>
                </ng-template>
                <app-account-management></app-account-management>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    <span>{{ 'admin.partner-management.title' | translate }}</span>
                </ng-template>
                <app-partners-management></app-partners-management>
            </mat-tab>
            <mat-tab>
                <ng-template mat-tab-label>
                    <span>{{ 'admin.update-management.title' | translate }}</span>
                </ng-template>
                <app-updates-management></app-updates-management>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>